import { render, staticRenderFns } from "./ModalExcluirAtaPncp.vue?vue&type=template&id=3d9b2623&scoped=true"
import script from "./ModalExcluirAtaPncp.vue?vue&type=script&lang=js"
export * from "./ModalExcluirAtaPncp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b2623",
  null
  
)

export default component.exports